module.exports = __webpack_public_path__ + "media/images/list-475fd311.png";